import { render } from "./ProductFormModal.vue?vue&type=template&id=2b10da32&scoped=true"
import script from "./ProductFormModal.vue?vue&type=script&lang=js"
export * from "./ProductFormModal.vue?vue&type=script&lang=js"

import "./ProductFormModal.vue?vue&type=style&index=0&id=2b10da32&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b10da32"]])

export default __exports__